"use client";
"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeProvider = exports.resetClassName = void 0;
const react_1 = require("@emotion/react");
const react_2 = __importDefault(require("react"));
const theme_ui_1 = require("theme-ui");
const useExpandContent_1 = require("../../hooks/useExpandContent");
const useId_1 = require("../../hooks/useId");
const useOverlay_1 = require("../../hooks/useOverlay");
const Fonts_1 = require("../Fonts");
const IconContext_1 = require("../Icon/IconContext");
const ThemeV2_1 = require("../ThemeV2");
const ThemeContext_1 = require("./ThemeContext");
const ThemeProfiles_1 = require("./ThemeProfiles");
const types_1 = require("./types");
exports.resetClassName = "mdrna-reset";
const ResetStyles = () => {
    const fontFacesDeclaration = react_2.default.useMemo(() => (0, Fonts_1.getFontFacesDeclaration)(), []);
    return (react_2.default.createElement(react_2.default.Fragment, null,
        react_2.default.createElement(theme_ui_1.Global, { styles: {
                [`.${exports.resetClassName}`]: {
                    all: "unset",
                    cursor: "revert",
                    display: "revert",
                    verticalAlign: "baseline"
                },
                "*": {
                    WebkitTapHighlightColor: "transparent"
                }
            } }),
        react_2.default.createElement(react_1.Global, { styles: (0, react_1.css) `
          ${fontFacesDeclaration}
        ` })));
};
// TODO remove references to usingStyleInheritance} when upgrading to next major release (v3 / v4 ?) -EO
const ThemeProvider = ({ children, expandContent, mode = "light", theme: themeInitial = ThemeProfiles_1.ModernaTheme, themeBranding = ThemeV2_1.ModernaBrand, usingStyleInheritance = false, preCacheIcons = [] }) => {
    const { initialized, usingStyleInheritance: usingStyleInheritancePrevious } = react_2.default.useContext(ThemeContext_1.ThemeContext);
    const theme = react_2.default.useMemo(() => {
        const { colorsDark, colorsLight, sizes, space, radii, shadows, fontSizes, fontWeights, lineHeights } = themeInitial, themeWithoutColors = __rest(themeInitial, ["colorsDark", "colorsLight", "sizes", "space", "radii", "shadows", "fontSizes", "fontWeights", "lineHeights"]);
        const spaceObject = Object.assign(Object.assign(Object.assign({}, Object.values(space).reduce((obj, value, index) => {
            obj[index] = value;
            return obj;
        }, {})), sizes), ThemeV2_1.Space);
        const fontSizeObject = Object.assign(Object.assign({}, Object.values(fontSizes).reduce((obj, value, index) => {
            obj[index] = value;
            return obj;
        }, {})), ThemeV2_1.FontSize);
        const lineHeightObject = Object.assign(Object.assign({}, Object.values(lineHeights).reduce((obj, value, index) => {
            obj[index] = value;
            return obj;
        }, {})), ThemeV2_1.LineHeight);
        let brandName = "moderna";
        switch (themeBranding) {
            case ThemeV2_1.SpikevaxBrand:
                brandName = "spikevax";
                break;
            case ThemeV2_1.EducationBrand:
                brandName = "education";
                break;
            case ThemeV2_1.CovidDiseaseEducationBrand:
                brandName = "education-covid";
                break;
        }
        return Object.assign(Object.assign({}, themeWithoutColors), { colors: Object.assign(Object.assign(Object.assign({}, (mode === "light" ? colorsLight : colorsDark)), ThemeV2_1.SystemColors), (0, types_1.setColorsForThemeV2)(themeBranding, brandName)), sizes: spaceObject, space: spaceObject, shadows: Object.assign(Object.assign({}, shadows), ThemeV2_1.Elevation), radii: Object.assign(Object.assign({}, radii), ThemeV2_1.CornerRadii), fontSizes: fontSizeObject, fontWeights: Object.assign(Object.assign({}, fontWeights), ThemeV2_1.FontWeight), lineHeights: lineHeightObject, letterSpacings: ThemeV2_1.LetterSpacing, config: {
                useCustomProperties: false,
                useLocalStorage: false
            } });
    }, [mode, themeBranding, themeInitial]);
    // TODO remove usingStyleInheritance aspect of themeProvider when upgrading to next major release (v3 / v4 ?) -EO
    const themeContextNext = react_2.default.useMemo(() => ({
        initialized: true,
        mode,
        themeInitial: Object.assign(Object.assign({}, themeInitial), { sizes: Object.assign(Object.assign({}, themeInitial.sizes), theme.sizes) }),
        usingStyleInheritance: usingStyleInheritance || usingStyleInheritancePrevious
    }), [
        mode,
        theme,
        themeInitial,
        usingStyleInheritance,
        usingStyleInheritancePrevious
    ]);
    return initialized ? (react_2.default.createElement(react_2.default.Fragment, null, children)) : (react_2.default.createElement(useId_1.IdProvider, null,
        react_2.default.createElement(useExpandContent_1.ExpandContentProvider, { expandContent: expandContent || false },
            react_2.default.createElement(useOverlay_1.OverlayContextProvider, null,
                react_2.default.createElement(ThemeContext_1.ThemeContext.Provider, { value: themeContextNext },
                    react_2.default.createElement(theme_ui_1.ThemeUIProvider, { theme: theme },
                        react_2.default.createElement(IconContext_1.IconProvider, { preCacheIcons: preCacheIcons },
                            react_2.default.createElement(ResetStyles, null),
                            children)))))));
};
exports.ThemeProvider = ThemeProvider;
//# sourceMappingURL=Theme.js.map